<template>
  <div class="contact min-h-50 text-NotoSansRegular">
    <div class="sm:border borderColordarkgray2 rounded overflow-hidden">
      <div class="service">
        <div class="contact-body px-4 md:px-10 py-6 md:py-8">
          <div v-if="$route.name === 'magazineSendBack'" class="mb-4">
            <h4 class="mb-4 font-bold ml-2">雜誌訂戶服務</h4>
            <h6 class="ml-2">親愛的顧客您好：</h6>
            <p class="mb-2 ml-2">這裡僅提供訂戶編號查詢，若您需要申請雜誌補寄、轉換訂閱雜誌別、更改寄送地址或查詢到期期數等其他服務，請寫信至客服信箱
              <a class="underline text-blue-600" href="mailto:service@liveabc.com">service@liveabc.com</a>
              ，我們將竭誠為您服務。
            </p>
            <p class="mb-4 ml-2">LiveABC互動英語教學集團</p>
            <div class="flex flex-wrap text-center mb-2">
              <!-- <div class="w-full sm:w-1/2 px-1 mb-2 flex-grow flex">
                <a class="button-gray border py-5 px-4 rounded focus:outline-none block h-full text-sm md:text-base w-full"
                href="http://www1.liveabc.com/site/Online_Store/member/info_resend_magazine.asp" target="_blank">
                  <span>雜誌補寄申請</span>
                </a>
              </div> -->
              <!-- <div class="w-full sm:w-1/2 px-1 mb-2 flex-grow flex">
                <a class="button-gray border py-5 px-4 rounded focus:outline-none block h-full text-sm md:text-base w-full"
                href="http://www1.liveabc.com/site/Online_Store/member/info_search_mature.asp" target="_blank">
                  <span>查詢雜誌到期期數</span>
                </a>
              </div> -->
              <div class="w-full sm:w-1/2 px-1 mb-2 flex">
                <!-- href="http://www1.liveabc.com/site/Online_Store/member/info_search_id.asp" -->
                <router-link :to="{ name: 'subscriberNumbering' }" class="button-gray border py-5 px-4 rounded focus:outline-none block h-full text-sm md:text-base w-full"
                >
                  <span>查詢訂戶編號</span>
                </router-link>
              </div>
              <!-- <div class="w-full sm:w-1/2 px-1 mb-2 flex-grow flex">
                <a class="button-gray border py-5 px-4 rounded focus:outline-none block h-full text-sm md:text-base w-full"
                href="http://www1.liveabc.com/site/Online_Store/member/info_address_modification.asp" target="_blank">
                  <span>雜誌訂閱更動地址同意書</span>
                </a>
              </div> -->
              <!-- <div class="w-full sm:w-1/2 px-1 mb-2">
                <a class="button-gray border py-5 px-4 rounded focus:outline-none block h-full text-sm md:text-base w-full"
                href="http://www1.liveabc.com/site/Online_Store/member/service_change/mgz_change.asp" target="_blank">
                  <span>雜誌轉換同意書</span>
                </a>
              </div> -->
            </div>
            <p class="textColorRed mb-2 ml-2">
              &lt;注意事項&gt;<br/>
              ● How It Works知識大圖解無法與其他雜誌互換。<br/>
              ● 從第三期雜誌起，方可變更雜誌種類。<br/>
              例：起訂月為2021年1月，2021年3月起才可更換<br/>
              ● 更換日期若為當月10日前，次月雜誌即寄送轉換後的雜誌，若為當月10日後，則為次次月雜誌寄送轉換後的雜誌。<br/>
              例：6/10前可申請轉換7月號雜誌，若6/10後申請則轉換8月號雜誌。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MagTransform',
  metaInfo () {
    return {
      title: '雜誌訂戶服務',
      titleTemplate: null
    }
  },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .contact-body {
    min-height: 26em;
    @media (max-width: 1025px) {
      min-height: 20em;
    }
    @media (max-width: 769px) {
      min-height: 18em;
    }
    @media (max-width: 577px) {
      min-height: 16em;
    }
  }
</style>
